/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/

let navMenu = JSON.parse(localStorage.getItem('navMenu'));
let userInfo = JSON.parse(localStorage.getItem('userInfo'));
if(navMenu===null)
  navMenu = [];
if(userInfo.name==='admin'){
  const settings = {
    url: null,
    name: "Settings",
    icon: "SettingsIcon",
    i18n: "Settings",
    submenu: [
      {
        url: '/settings/dictionary',
        name: "Dictionary",
        slug: "dictionary",
        icon: "PlusIcon",
        i18n: "Dictionary",
      },
      {
        url: '/settings/users',
        name: "Users",
        slug: "users",
        icon: "UserPlusIcon",
        i18n: "Users",
      }],
  }
  //navMenu.push(settings);
}
export default navMenu